var endpointMap = {
	ar: {
		"pages.gru": "translation-ar.json"
	},
	"ar-SA": {
		"pages.gru": "translation-ar.json"
	},
	cs: {
		"pages.gru": "translation-cs.json"
	},
	"cs-CZ": {
		"pages.gru": "translation-cs.json"
	},
	de: {
		"pages.gru": "translation-de.json"
	},
	"de-DE": {
		"pages.gru": "translation-de.json"
	},
	en: {
		"pages.gru": "translation-en.json"
	},
	"en-US": {
		"pages.gru": "translation-en.json"
	},
	es: {
		"pages.gru": "translation-es.json"
	},
	"es-ES": {
		"pages.gru": "translation-es.json"
	},
	fr: {
		"pages.gru": "translation-fr.json"
	},
	"fr-CA": {
		"pages.gru": "translation-fr.json"
	},
	"fr-FR": {
		"pages.gru": "translation-fr.json"
	},
	it: {
		"pages.gru": "translation-it.json"
	},
	"it-IT": {
		"pages.gru": "translation-it.json"
	},
	ja: {
		"pages.gru": "translation-ja.json"
	},
	"ja-JP": {
		"pages.gru": "translation-ja.json"
	},
	pl: {
		"pages.gru": "translation-pl.json"
	},
	"pl-PL": {
		"pages.gru": "translation-pl.json"
	},
	und: {
		"pages.gru": "translation.json"
	}
};
var arbManifest = {
	endpointMap: endpointMap
};

export { arbManifest as default, endpointMap };
